import * as Sentry from '@sentry/react'

export type SentryLogEvent = {
  message?: string
  attributes?: Record<string, unknown>
}

type LogAttributes = Record<string, string | number | boolean>

const NOISY_LOG_PATTERN =
  /DialogContent[\s\S]*DialogTitle|invalidAccountId|"name"\s*:\s*"AxiosError"|API ERROR|ERR_NETWORK|ERR_BAD_REQUEST|ECONNABORTED|Request failed with status code|"password"\s*:|Tranzila charge error/i

function safeJson(value: unknown): string {
  try {
    return JSON.stringify(value) ?? ''
  } catch {
    return ''
  }
}

function logHaystack(log: SentryLogEvent): string {
  return `${log.message ?? ''} ${safeJson(log.attributes)}`
}

export function shouldDropSentryLog(log: SentryLogEvent): boolean {
  return NOISY_LOG_PATTERN.test(logHaystack(log))
}

export function beforeSendSentryLog<T extends SentryLogEvent>(log: T): T | null {
  if (shouldDropSentryLog(log)) {
    return null
  }
  return log
}

export function logWarn(message: string, attributes?: LogAttributes): void {
  Sentry.logger.warn(message, attributes)
}

export function logError(message: string, attributes?: LogAttributes): void {
  Sentry.logger.error(message, attributes)
}
